import { jsxs, jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { InsetIcon } from "../Icons/index.es.js";
import stitches from "../theme.config.es.js";
import EzListBox from "./EzListBox.es.js";
import EzTextInput from "./EzTextInput.es.js";
import { TextInputWrapper } from "./Picker.styles.es.js";
import { useComboBoxState, useComboBox } from "./useComboBox.es.js";
import useUpdateEffect from "../../utils/hooks/useUpdateEffect.es.js";
import EzIcon from "../EzIcon/EzIcon.es.js";
import EzPopover from "../EzPopover/EzPopover.es.js";
const popper = stitches.css({
  zIndex: "$autosuggest-z"
  // this is hard-coded in theme.config.ts for now, but we should really pull it in from mui when we convert autosuggest to mui
});
const iconWrapperStyle = stitches.css({
  alignItems: "center",
  display: "flex",
  fontSize: "13px"
});
const searchIconStyle = stitches.css({
  backgroundRepeat: "no-repeat",
  backgroundPosition: "12px center, calc(100% - 10px) center",
  backgroundImage: "$search-input-background-image",
  "&&": {
    paddingLeft: "$search-input-padding-left"
  },
  WebkitAppearance: "none"
});
const EzAutosuggest = ({ loading, options, ...props }) => {
  const triggerRef = useRef();
  const listboxRef = useRef();
  const ariaLabelledBy = props["aria-labelledby"];
  const loadingOptions = [{ label: "Loading...", value: "loading", disabled: true }];
  const stateOptions = loading ? loadingOptions : options;
  const state = useComboBoxState({ options: stateOptions, ...props });
  const { inputProps, listBoxProps } = useComboBox(
    {
      ...props,
      triggerRef,
      popoverRef: listboxRef
    },
    state
  );
  useUpdateEffect(() => {
    if (props.value != null) state.setInputValue(props.value);
  }, [props.value]);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(
      TextInputWrapper,
      {
        className: props.className,
        disabled: props.disabled,
        css: {
          "&& input": { paddingRight: props.type === "autosuggest-search" ? "0.5em" : void 0 }
        },
        children: [
          /* @__PURE__ */ jsx(
            EzTextInput,
            {
              ...inputProps,
              className: props.type === "autosuggest-search" ? searchIconStyle() : void 0,
              error: props.error,
              ref: triggerRef,
              touched: props.touched,
              type: "search"
            }
          ),
          props.type === "autosuggest" && /* @__PURE__ */ jsx(InsetIcon, { insetY0: true, right0: true, pr2: true, children: /* @__PURE__ */ jsx("div", { className: iconWrapperStyle(), children: /* @__PURE__ */ jsx(EzIcon, { icon: state.isOpen ? faChevronUp : faChevronDown, size: "inherit" }) }) })
        ]
      }
    ),
    state.isOpen && /* @__PURE__ */ jsx(
      EzPopover,
      {
        shouldCloseOnBlur: true,
        onClose: state.close,
        targetRef: triggerRef,
        placement: "bottom-start",
        matchWidth: true,
        className: popper(),
        classNameSuffix: props.classNameSuffix,
        children: /* @__PURE__ */ jsx(
          EzListBox,
          {
            ...listBoxProps,
            "aria-labelledby": [ariaLabelledBy, props.id].join(" "),
            collection: state.collection,
            onClick: () => triggerRef.current.focus(),
            ref: listboxRef,
            searchWords: [inputProps.value],
            selectionManager: state.selectionManager
          }
        )
      }
    )
  ] });
};
export {
  EzAutosuggest as default
};
//# sourceMappingURL=EzAutosuggest.es.js.map
